import React from "react";

function Logo({ className, style, src, alt }) {
    return (
        <div className="text-center mx-auto" style={style}>
            <img className={className} alt={alt} src={src} />
        </div>
    );

}

export default Logo;
